<template>
	<div style="background: #f3f4f7">
		<userHeader />
		<fuHeader />
		<crumbs :txt="a" type="2" height="53px" />
		<div class="bodyWrapper">
			<div class="gudBtns">
				<div class="gudBtnItem gudBack supHove3" @click="$router.back()">
					<img src="@/assets/img/back.svg" alt="" />
					<span>返回</span>
				</div>
			</div>
			<div class="banjBox">
				<div class="banjInfo">
					<div class="banjImg">
						<div>
							<img :src="qrCodeImage" v-if="qrCodeImage" alt="" />
						</div>
						<p>扫码加入班级</p>
					</div>
					<div class="banjC">
						<h2>{{ infoData.school }}{{ bjData.grade }}{{ bjData.name }}</h2>
						<p>
							<span>班级状态</span>
							<el-radio-group v-model="ruleForm.status" @change="ztFn">
								<el-radio :label="1">开启</el-radio>
								<el-radio :label="0">关闭</el-radio>
							</el-radio-group>
						</p>
						<p>
							<span>班级入驻</span>
							<el-radio-group v-model="ruleForm.addAuditFlag" @change="ztFn">
								<el-radio :label="1">审核</el-radio>
								<el-radio :label="0">不审核</el-radio>
							</el-radio-group>
						</p>
					</div>
					<div class="banjBg">
						<img src="@/assets/img/编组 18.png" alt="" />
					</div>
					<div class="banjXsBtn" @click="mrFn" :class="bjData.default ? 'banjXsBtn1' : ''">默认显示</div>
					<div class="banjJcBtn" @click="delFn">
						<img src="@/assets/img/编组 (10).png" alt="" />
						解除班级
					</div>
				</div>
				<div class="banjiCont">
					<div class="banjiContLeft">
						<div class="banjiContItem" @click="tabBtn(1, 'chengYuan')" :class="flags == 1 ? 'active' : ''">成员管理</div>
						<div class="banjiContItem" @click="tabBtn(2, 'keben')" :class="flags == 2 ? 'active' : ''">班级课本</div>
						<div class="banjiContItem" @click="tabBtn(3, 'banjiSj')" :class="flags == 3 ? 'active' : ''">班级试卷</div>
						<div class="banjiContItem" @click="tabBtn(8, 'jikaoSj')" :class="flags == 8 ? 'active' : ''">机考套题</div>
						<div class="banjiContItem" @click="tabBtn(4, 'gaokaoZts')" :class="flags == 4 ? 'active' : ''">高考真题</div>
						<div class="banjiContItem" @click="tabBtn(5, 'meiriYts')" :class="flags == 5 ? 'active' : ''">每日一听</div>
						<!-- 套题分享入口暂时隐藏：该功能跨班级使用，不应放在单个班级详情中。 -->
						<div class="banjiContItem" @click="tabBtn(6, 'danciP')" :class="flags == 6 ? 'active' : ''">单 词 簿</div>
						<div class="banjiContItem" @click="tabBtn(7, 'cuotiBen')" :class="flags == 7 ? 'active' : ''">错 题 本</div>
					</div>
					<div class="banjiContRig">
						<component
							:is="currentComponent"
							:a="a"
							:pageType="pageType"
							:retTxt="retTxt"
							@fhBtns="fhBtns"
							@fhBtn="fhBtn"
							:examId="examId"
							@fbBtn="fbBtn"
							:ctId="ctId"
							:userTextbookId="userTextbookId"
							:examData="examData"
							:examArrData="examArrData"
							@ctkbFn="ctkbFn"
							@exaFn="exaFn"
							@exaArrFn="exaArrFn"
							:ztId="ztId"
							@ztsFn="ztsFn"
							@ctFn="ctFn"
							:dcbId="dcbId"
							@dcbBtn="dcbBtn"
							:bjId="id"
							@paperFn="paperFn"
							:paperId="paperId"
							:paperType="paperType"
							:dailyReportExam="dailyReportExam"
							@dailyReportFn="dailyReportFn"
							@answerReportFn="answerReportFn"
							:reportSource="reportSource"
							:paperSide="reportPaperSide"
							:computerizedPaperId="computerizedPaperId"
							@report-back="reportBack"
						></component>
					</div>
				</div>
			</div>
		</div>
		<foot />
	</div>
</template>

<script>
import foot from '@/components/foot/foot';
import userHeader from '@/components/hearder/userHeader';
import fuHeader from '@/components/hearder/fuHeader';
import crumbs from '@/components/hearder/crumbs';
// 成员管理
import chengYuan from '@/components/banji/chengYuan';
// 班级课本
import keben from '@/components/banji/keben';
import kebenDec from '@/components/banji/kebenDec';
import textbookReport from '@/components/banji/textbookReport';
import cuotiFb from '@/components/banji/cuotiFb';
import cuotiJlu from '@/components/banji/cuotiJlu';
import cuotiFbjlu from '@/components/banji/cuotiFbjlu';
// 班级试卷
import banjiSj from '@/components/banji/banjiSj';
import banjiSjDecSec from '@/components/banji/banjiSjDecSec';
// 高考真题
import gaokaoZts from '@/components/banji/gaokaoZts';
// 每日一听
import meiriYts from '@/components/banji/meiriYts';
import dailyAnswerReport from '@/components/banji/dailyAnswerReport';
// 单 词 簿
import danciP from '@/components/banji/danciP';
import danciPDec from '@/components/banji/danciPDec';
// 错 题 本
import cuotiBen from '@/components/banji/cuotiBen';
import { mapState } from 'vuex';
// 机考套题
import jikaoSj from '@/components/banji/jikaoSj';

export default {
	name: 'banjiHome',
	data() {
		return {
			txt: '',
			ctId: '',
			examId: '',
			ztId: '',
			pageType: '',
			examData: '',
			examArrData: '',
			userTextbookId: '',
			ruleForm: {
				addAuditFlag: '',
				status: ''
			},
			qrCodeImage: '',
			dcbId: '',
			retTxt: '',
			id: '', // 班级id
			bjData: {},
			flags: 1,
			currentComponent: 'chengYuan',
			a: ['班级列表'],
			paperId: '',
			paperType: '',
			fromRoute: null,
			dailyReportExam: null,
			reportSource: 'daily',
			reportPaperSide: '',
			computerizedPaperId: null
		};
	},
	components: {
		userHeader,
		fuHeader,
		crumbs,
		chengYuan,
		keben,
		kebenDec,
		textbookReport,
		cuotiFb,
		cuotiJlu,
		cuotiFbjlu,
		banjiSj,
		banjiSjDecSec,
		gaokaoZts,
		meiriYts,
		dailyAnswerReport,
		danciP,
		danciPDec,
		cuotiBen,
		foot,
		jikaoSj
	},
	methods: {
		dailyReportFn(item) {
			this.dailyReportExam = item;
			this.reportSource = 'daily';
			this.reportPaperSide = '';
			this.computerizedPaperId = null;
		},
		answerReportFn(item) {
			this.dailyReportExam = item;
			this.reportSource = item.reportSource || 'daily';
			this.reportPaperSide = item.paperSide || '';
			this.computerizedPaperId = this.reportSource === 'computerized' ? item.examId : null;
		},
		reportBack(source) {
			const targets = { college: 'gaokaoZts', classExam: 'banjiSj', computerized: 'jikaoSj', daily: 'meiriYts' };
			this.currentComponent = targets[source] || 'meiriYts';
		},
		ewmaFn() {
			let url = '';
			// 班级二维码
			url = `pages/home/a_resources/resources-search-list?id=${this.id}`;
			this.$http
				.get('api/app/common/getMiniProgramsCodes', {
					params: {
						url,
						clientType: '1'
					},
					responseType: 'blob'
				})
				.then((res) => {
					if (res) {
						const blob = new Blob([res], { type: 'image/png' });
						this.qrCodeImage = URL.createObjectURL(blob);
					}
				});
		},
		ztsFn(id) {
			this.ztId = id;
		},
		dcbBtn(id) {
			this.dcbId = id;
		},
		exaArrFn(item) {
			this.examArrData = item;
		},
		exaFn(item) {
			this.examData = item;
		},
		ctkbFn(id) {
			this.userTextbookId = id;
		},
		ctFn(id) {
			this.ctId = id;
		},
		paperFn(id, pageType, paperType) {
			this.paperId = id;
			this.pageType = pageType;
			this.paperType = paperType;
		},
		fbBtn(id, pageType) {
			this.pageType = pageType;
			this.examId = id;
		},
		tabBtn(type, conTxt) {
			this.flags = type;
			this.currentComponent = conTxt;
		},
		ztFn() {
			console.log(this.ruleForm, 9999);
			this.changeBj(this.ruleForm);
		},
		mrFn() {
			if (this.bjData.default) {
				this.$message({
					message: '该班级已经是默认班级啦',
					type: 'warning'
				});
				return;
			}
			this.changeBj({
				isDefault: this.bjData.default ? 0 : 1
			});
		},
		lookBtn(txt) {
			this.$router.push({
				path: './timDec',
				query: {
					types: 'zt',
					txt,
					crumFlag: 1,
					tabFtxt: ['首页', '高考真题']
				}
			});
		},
		fhBtn(type) {
			console.log(type, 333);
			this.retTxt = this.currentComponent;
			this.currentComponent = type;
		},
		fhBtns(type, name) {
			console.log(type, 333);
			this.retTxt = name;
			this.currentComponent = type;
		},
		changeBj(data) {
			let set = this.$loading(this.$pre);
			this.$http
				.put('api/app/yydBj', {
					bjId: this.id,
					...data
				})
				.then((res) => {
					set.close();
					if (res.code == 200) {
						this.$message({
							message: '修改成功',
							type: 'success'
						});
						this.init();
					}
				});
		},
		init() {
			this.$http.get(`/api/app/yydBj/${this.id}`).then((res) => {
				console.log(res, 9999);
				if (res.code == 200) {
					this.bjData = res.data;
					this.ruleForm.addAuditFlag = res.data.addAuditFlag;
					this.ruleForm.status = res.data.status;
				}
			});
		},
		delFn() {
			this.$confirm('解除班级后将无法恢复，是否解散班级?', '提示', {
				confirmButtonText: '解散',
				confirmButtonClass: 'delBtns',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					let set = this.$loading(this.$pre);
					this.$http.delete(`api/app/yydBj/${this.id}`).then((res) => {
						set.close();
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: '解散成功'
							});
							setTimeout(() => {
								this.$router.replace({
									path: 'myBanji'
								});
							}, 500);
						}
					});
				})
				.catch(() => {});
		}
	},
	computed: {
		...mapState(['infoData'])
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			vm.fromRoute = from.path;
		});
	},
	activated() {
		console.log('activated');
		const { id, txt, tabFtxt } = this.$route.query;
		console.log(this.$route.params, 8888);
		
		// 如果当前组件是jikaoSj，且从mySj页面返回，刷新jikaoSj组件
		if (this.currentComponent === 'jikaoSj' && this.fromRoute === '/mySj') {
			this.$nextTick(() => {
				const jikaoSjComponent = this.$children.find(child => child.$options.name === 'jikaoSj');
				if (jikaoSjComponent && jikaoSjComponent.init) {
					jikaoSjComponent.init();
				}
			});
		}
		
		if (this.$route.params.sxStatus || (this.id && id != this.id)) {
			const isSameClass = String(id) === String(this.id);
			if (tabFtxt) {
				this.a = typeof tabFtxt == 'string' ? [tabFtxt] : [...tabFtxt];
			}
			this.txt = txt || '';
			this.a.pop();
			this.a.push(txt);
			this.id = id;
			this.flags = 1;
			this.currentComponent = 'chengYuan';
			this.ewmaFn();
			this.init();
			if (isSameClass) {
				this.$nextTick(() => {
					const chengYuanComponent = this.$children.find((child) => child.$options.name === 'chengYuan');
					if (chengYuanComponent && chengYuanComponent.resetAndLoad) {
						chengYuanComponent.resetAndLoad();
					}
				});
			}
		}
	},
	mounted() {
		console.log('mounted');
		const { id, txt, tabFtxt } = this.$route.query;
		if (tabFtxt) {
			this.a = typeof tabFtxt == 'string' ? [tabFtxt] : [...tabFtxt];
		}
		this.txt = txt || '';
		this.a.push(txt);
		this.id = id;
		this.ewmaFn();
		this.init();
	}
};
</script>
<style lang="scss" scoped>
.banjBox {
	width: 1200px;
	margin: 0 auto 10px;
	.banjInfo {
		background: #ffffff;
		border-radius: 6px;
		padding: 20px 33px 0;
		box-sizing: border-box;
		position: relative;
		display: flex;
		height: 190px;
		.banjImg {
			width: 130px;
			margin-right: 49px;
			div {
				width: 130px;
				height: 130px;
				margin-bottom: 10px;
			}
			img {
				width: 100%;
				height: 100%;
				vertical-align: bottom;
			}
			p {
				font-size: 14px;
				color: #000000;
				text-align: center;
			}
		}
		.banjXsBtn {
			width: 64px;
			height: 24px;
			background: #e8f1eb;
			border-radius: 2px;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 12px;
			color: #1d7b3a;
			position: absolute;
			z-index: 1;
			top: 22px;
			cursor: pointer;
			right: 21px;
		}
		.banjXsBtn1 {
			background: #1d7b3a;
			color: #fff;
		}
		.banjJcBtn {
			width: 90px;
			height: 30px;
			background: #fa4a1b;
			border-radius: 4px;
			font-size: 14px;
			color: #ffffff;
			display: flex;
			align-items: center;
			justify-content: center;
			position: absolute;
			bottom: 20px;
			right: 21px;
			z-index: 1;
			cursor: pointer;
			img {
				width: 15px;
				height: 16px;
				margin-right: 4px;
			}
		}
		.banjBg {
			position: absolute;
			right: 241px;
			bottom: 0;
			img {
				height: 144px;
			}
		}
		.banjC {
			flex: 1;
			display: flex;
			flex-direction: column;
			height: 100%;
			position: relative;
			z-index: 1;
			h2 {
				font-weight: bold;
				font-size: 18px;
				color: #000000;
				margin-top: 20px;
				margin-bottom: 21px;
			}
			p {
				display: flex;
				align-items: center;
				font-size: 14px;
				color: #000000;
				&:first-of-type {
					margin-bottom: 18px;
				}
				span {
					font-size: 14px;
					color: #000000;
					margin-right: 32px;
				}
			}
		}
	}
	.banjiCont {
		margin: 10px 0 30px;
		display: flex;
		.banjiContLeft {
			width: 130px;
			min-width: 130px;
			flex: 0 0 130px;
			padding: 10px 13px;
			box-sizing: border-box;
			margin-right: 10px;
			background: #ffffff;
			border-radius: 6px;
			.banjiContItem {
				height: 40px;
				margin-bottom: 10px;
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 14px;
				color: #000000;
				cursor: pointer;
				white-space: nowrap;
			}
			.active {
				background: #e8f1eb;
				font-weight: bold;
				font-size: 14px;
				color: #1d7b3a;
			}
		}
		.banjiContRig {
			background: #ffffff;
			border-radius: 6px;
			flex: 1;
			min-width: 0;
			overflow: hidden;
		}
	}
}
</style>
